import { block, cliCommand } from "common/api";

export function parseLinkStateResponse(response)  {
  const attrs = [];
  const lines = response.split("\n");
  for (const line of lines) {
    const words = line.trim().split(/:\s+|\s{2,}/);

    for (let i = 0; i < words.length; i += 2) {
      if (words[i]) {
        attrs.push({ label: words[i], value: words[i + 1] });
      }
    }
  }

  const firstElement = attrs[0];
  attrs.splice(0, 1, { label: "Flags", value: firstElement.value });
  attrs.splice(0, 0, { label: "Name", value: firstElement.label });

  return attrs;
}

export function parseLinkStateDeviceResponse(response) {
  const attrs = [];
  const lines = response.split("\n");
  for (const line of lines) {
    const words = line.trim().split(/:(.*)/);

    for (let i = 0; i < words.length; i += 2) {
      if (words[i]) {
        attrs.push({ label: words[i], value: words[i + 1] });
      }
    }
  }
  return attrs;
}

const upOrDown = (value) =>
  value === "up" ? true : value === "down" ? false : undefined;

const yesOrNo = (value) =>
  value === "yes" ? true : value === "no" ? false : undefined;

const ATTR_MAP = {
   IFACE: "name",
   TYPE: "type",
   MAC: "mac",
   STATE: "enabled",
   LINK: "connected",
   MGMT: "management",
   BQN: "bqn",
   "ENABLE-STATUS": "enable-status"
}

export const parseInterfaces = (response) => {
  const [header, ...rows] = response.trim("\n").split("\n");
  const headerAttrs = header.trim("s").split(/\s+/);
  const indexAttrMap = headerAttrs.reduce((acc, value, index)=>{
   acc[index] = value;
   return acc;
  }, {})
  return rows.map((row)=> {
    const matchResult = row.match(/%ERR-ENOENT: Cannot get "(.*)" interface information/);
    if(matchResult){
      return {
        bqn: null,
        name: matchResult[1],
        type: 'n/a',
        mac: 'n/a',
        enabled: undefined,
        connected: undefined,
        management: false,
      };
    }

    const rowAttrs = row.trim("s").split(/\s+/);
    return rowAttrs.reduce((acc, attr, index)=>{
      const key = ATTR_MAP[indexAttrMap[index]];
      if(key==="enabled"){
        acc[key] = upOrDown(attr);
      } else if (key === "connected" || key === "management"){
        acc[key] = yesOrNo(attr);
      } else if (key!=="enable-status"){
        acc[key] = attr;
      }
       return acc;
    }, {})
  });
};

const configureBlock = block({
  optional: true,
  start: "configure",
  end: "commit",
  enter: false,
});

export const updateCommand = (name, { enable = false, disable = true }) =>
  cliCommand`
    ${configureBlock([
      `interface ${name}`,
      enable ? "enabled" : disable ? "disabled" : "",
      "exit",
    ]).join("\n")}
  `(false /*enter*/);